import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import soTranslations from './locales/so.json';

const resources = {
  en: {
    translation: enTranslations
  },
  so: {
    translation: soTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
    },
    
    react: {
      useSuspense: false,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
    
    // Ensure smooth language switching
    load: 'languageOnly',
    cleanCode: true,
    
    // Add missing key handler
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} for language: ${lng}`);
      }
      return fallbackValue || key;
    },
    
    // Ensure all resources are loaded before initialization
    initImmediate: false,
    
    // Add better error handling
    saveMissing: false,
    updateMissing: false,
    
    // Improve performance
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n;